import React, { useContext, useState } from "react";
import "./header.css";
import { Link, useNavigate } from "react-router-dom";
import { baseRequest } from "../../axiosconfig";
import { UserContext } from "../../userContext";

export default function Header({ isLoggedin, setIsloggedin, setLoading, onToggleSidebar }) {
  const navigate = useNavigate();
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const { setUser } = useContext(UserContext);

  function handleLogout() {
    setLoading(true);
    baseRequest
      .post("/logout", {})
      .then((res) => {
        setUser(null);
        navigate("/login");
        setIsloggedin(false);
        setLoading(false);
      })
      .catch(() => {
        setLoading(false);
      });
  }

  function closeMenu() {
    setMobileMenuOpen(false);
  }

  return (
    <div className="header">
      <div>
        <img src="/Logo.png" alt="Finansijsko upravljanje i kontrola" className="header-logo" />
      </div>

      {/* Logged in: hamburger opens sidebar */}
      {isLoggedin && (
        <button
          className="hamburger-btn"
          onClick={onToggleSidebar}
          aria-label="Toggle sidebar"
        >
          <span className="hamburger-line"></span>
          <span className="hamburger-line"></span>
          <span className="hamburger-line"></span>
        </button>
      )}

      {/* Not logged in: hamburger opens nav dropdown */}
      {!isLoggedin && (
        <button
          className="hamburger-btn"
          onClick={() => setMobileMenuOpen((prev) => !prev)}
          aria-label="Toggle menu"
        >
          <span className="hamburger-line"></span>
          <span className="hamburger-line"></span>
          <span className="hamburger-line"></span>
        </button>
      )}

      <nav className={`navigation ${!isLoggedin && mobileMenuOpen ? "navigation--open" : ""}`}>
        {!isLoggedin && (
          <Link className="navigation-item" to="/login" onClick={closeMenu}>
            Prijavite se
          </Link>
        )}
        {!isLoggedin && (
          <Link className="navigation-item" to="/register" onClick={closeMenu}>
            Registrujte se
          </Link>
        )}

        {isLoggedin && (
          <Link
            onClick={() => handleLogout()}
            className="navigation-item"
          >
            Odjavite se
          </Link>
        )}
      </nav>
    </div>
  );
}
